import { Link, useLoaderData } from 'react-router'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'
import { getAllTags } from '#app/utils/posts.server.ts'
import { type Route } from './+types/index.ts'

export const meta = ({ loaderData }: Route.MetaArgs) => {
	// const searchQuery = new URLSearchParams(
	// 	location.search
	//   ).get("q");
    // return [{ title: `Search results for "${searchQuery}"` }];

	var title = `JaseOwns - ${loaderData?.tags.length} Tags`;
	var description = "Browse through all the tags I've used in my posts.";
	return [
		{ title: title },
	  	{ name: "description", content: description},
	  	{ name: "keywords", content: "blog,games,uo,ultima online,self taught,learning,jaseowns,jase,jason"},
		{ property: "og:image", content: "https://jaseowns.com/images/blogs/blog-posts-root.png"},
		{ property: "og:image:alt", content: "Blog Posts in orange and white with black background"},
		{ property: "twitter:card", content: "summary"},
		{ property: "twitter:creator", content: "@jaseowns"},
		{ property: "twitter:site", content: "@jaseowns"},
		{ property: "og:title", content: title},
		{ property: "og:description", content: description},
	];
  };


export async function loader({ request }: Route.LoaderArgs) {

	const tags = await getAllTags()

	return {
			tags
		}
}

export default function Index() {
	const { tags } = useLoaderData<typeof loader>()


	return (
		<main className="container mx-auto text-black dark:text-white">
			<h1 className="text-3xl px-10 mb-6 text-cyan-900 dark:text-cyan-200">Tags ({tags.length})</h1>
			<div className="px-10">
				<div className="flex flex-col md:flex-row my-6">
					Browse through all the tags I've used in my posts.
				</div>
			</div>

			<div className="px-10">
				{tags.map(tag => (
					<div key={tag.slug}>
						<Link to={`/tags/${tag.slug}`}>{tag.name}</Link>
					</div>
				))}
			</div>

			
			<div className="flex flex-wrap justify-center gap-8 rounded-3xl py-4 mt-10">
				{WatchCTA()}
			</div>
		</main>
	)
}